import React, { Component } from 'react';
import { Select as ImportSelect } from 'semantic-ui-react';
import excludeKeys from '../../../../utils/excludeKeys';

class Select extends Component {
  render() {
    return (
      <ImportSelect {...excludeKeys(this.props)} />
    );
  }
}

export default Select;
